import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const ItemWrapper = styled("div")`
    display: grid;
    grid-template-columns: 5.5rem auto;
    grid-template-rows: auto auto;
    padding: 1rem 0;
    && > a {
        flex-direction: inherit;
    }
    border-width: 0;
`

export const BannerWrapper = styled("div")`
    grid-column: 1/3;
`
export const SalePrice = styled("p")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    color: ${({theme}) => `${theme.uxfabric.brand.sale.default.textColor}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    text-align: right;
    margin: 0;
`
